import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/v1/admin_api/login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/v1/admin_api/userinfo',
    method: 'get',
    params: { }
  })
}

export function logout(token) {
  return request({
    url: '/v1/admin_api/logout',
    method: 'post',
    data: { token }
  })
}

export function getAminUsers(query) {
  return request({
    url: '/v1/admin_api/users',
    method: 'get',
    params: query
  })
}

export function fetchAdminUserInfo(user_name) {
  return request({
    url: `/v1/admin_api/users/${user_name}`,
    method: 'get',
    params: {}
  })
}

export function createAdminUser(data) {
  return request({
    url: '/v1/admin_api/users',
    method: 'post',
    data
  })
}

export function updateAdminUser(data, user_name) {
  return request({
    url: `/v1/admin_api/users/${user_name}`,
    method: 'put',
    data
  })
}

export function deleteAdminUser(data, user_name) {
  return request({
    url: `/v1/admin_api/user/${user_name}`,
    method: 'delete',
    data
  })
}

export function weichatLogin(data) {
  return request({
    url: '/v1/admin_api/qrlogin',
    method: 'post',
    data
  })
}

export function fetchAllRoles() {
  return request({
    url: '/v1/admin_api/roles',
    method: 'get',
    params: {}
  })
}

export function updatePassword(data, user_name) {
  return request({
    url: `/v1/admin_api/user/password/${user_name}`,
    method: 'put',
    data
  })
}

export function getAdminUserTypes() {
  return request({
    url: `/v1/admin_api/user/types`,
    method: 'get',
    params: {}
  })
}
